import { useState, type FormEvent } from "react";
import { Button, Notice, TextField } from "../ui";
import { Select } from "../ui/Layout";
import { useGeraetAnmelden } from "./api";
import { ApiFehler } from "../api/client";

/** Dieses Gerät einmalig als Kasse anmelden (ersetzt die Web-Sitzung durch eine Gerätesitzung). */
export function GeraetAnmelden() {
  const anmelden = useGeraetAnmelden();
  const [name, setName] = useState("Kasse 1");
  const [art, setArt] = useState<"tablet" | "handy">(window.innerWidth < 760 ? "handy" : "tablet");
  const [scanner, setScanner] = useState<"kamera" | "bluetooth">("kamera");
  const [fehler, setFehler] = useState<string | null>(null);

  async function absenden(e: FormEvent) {
    e.preventDefault();
    setFehler(null);
    if (!name.trim()) return setFehler("Bitte einen Gerätenamen eingeben.");
    try {
      await anmelden.mutateAsync({ name: name.trim(), art, scannerArt: scanner });
      window.location.assign("/kasse");
    } catch (err) {
      setFehler(err instanceof ApiFehler ? err.message : "Das hat nicht geklappt.");
    }
  }

  return (
    <div className="app-public">
      <form className="app-public__card" onSubmit={absenden} noValidate>
        <h1 className="title">Dieses Gerät als Kasse anmelden</h1>
        <p className="sc-muted">Danach wechseln die Mitarbeitenden nur noch per PIN. Das Gerät bleibt 180 Tage angemeldet.</p>
        {fehler ? <Notice tone="error">{fehler}</Notice> : null}
        <TextField label="Gerätename" value={name} onChange={(e) => setName(e.target.value)} hint="z. B. Kasse 1, iPad Theke" autoFocus />
        <Select label="Gerät" value={art} onChange={(e) => setArt(e.target.value as "tablet" | "handy")}>
          <option value="tablet">Tablet</option>
          <option value="handy">Handy</option>
        </Select>
        <Select label="Scannen mit" value={scanner} onChange={(e) => setScanner(e.target.value as "kamera" | "bluetooth")} hint="Ein Bluetooth-Scanner funktioniert zusätzlich immer.">
          <option value="kamera">Kamera</option>
          <option value="bluetooth">Bluetooth-Handscanner</option>
        </Select>
        <Button type="submit" variant="primary" size="lg" icon="check" block loading={anmelden.isPending}>
          Als Kasse anmelden
        </Button>
      </form>
    </div>
  );
}
